module.exports = __webpack_public_path__ + "static/media/comment-add-svgrepo-com (1).5d30f7fa.svg";